import React, { useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import debounce from 'lodash/debounce';
import { setMeta } from '../../../features/networkUndoSlice';
import { formatMetaDate } from '../../../lib/metaDates';

const FIELDS = {
  title: 'Title',
  description: 'Description',
  version: 'Version',
  authors: 'Author(s)',
};

const minRowsFor = (key) => {
  if (key === 'description') return 12;
  if (key === 'authors') return 3;
  return 1;
};

export default function Meta() {
  const storedMeta = useSelector((state) => state.networkUndo.present.meta);
  const meta = useMemo(() => storedMeta || {}, [storedMeta]);
  const dispatch = useDispatch();
  const [form, setForm] = useState({});

  const debouncedUpdateMeta = useMemo(
    () => debounce((next) => dispatch(setMeta(next)), 500),
    [dispatch],
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextForm = { ...form, [name]: value };
    setForm(nextForm);
    debouncedUpdateMeta({ ...meta, ...nextForm });
  };

  useEffect(() => {
    setForm(meta);
  }, [meta]);

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      {Object.keys(FIELDS).map((key) => (
        <TextField
          fullWidth
          size="small"
          value={form[key] || ''}
          name={key}
          label={FIELDS[key]}
          onChange={handleChange}
          key={key}
          multiline={key === 'description' || key === 'authors'}
          minRows={minRowsFor(key)}
        />
      ))}
      <Box>
        <Typography variant="caption" color="text.secondary">Date created</Typography>
        <Typography variant="body2">{formatMetaDate(meta.date_created)}</Typography>
      </Box>
      <Box>
        <Typography variant="caption" color="text.secondary">Last modified</Typography>
        <Typography variant="body2">{formatMetaDate(meta.last_modified)}</Typography>
      </Box>
    </Stack>
  );
}
